import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { SharedDataProvider } from '../../providers/shared-data/shared-data';
import { ConfigProvider } from '../../providers/config/config';
import { Http } from '@angular/http';
import { LoadingProvider } from '../../providers/loading/loading';
import { OrderPage } from '../order/order';
declare var Appsee:any;

@Component({
  selector: 'page-shipping-method',
  templateUrl: 'shipping-method.html',
})
export class ShippingMethodPage {
  shippingMethod = new Array;
  selectedMethod = true;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public shared: SharedDataProvider,
    public http: Http,
    public config: ConfigProvider,
    public loading: LoadingProvider,
  ) {
    // Appsee.startScreen("LocalPickup");
    var isSpecialPricing = false;
    this.loading.show();
    var data: { [k: string]: any } = {};
    data.tax_zone_id = this.shared.orderDetails.tax_zone_id;
    // data.shipping_method = this.shared.orderDetails.shipping_method;
    // data.shipping_method = 'upsShipping';
    // data.shipping_method_code = this.shared.orderDetails.shipping_method_code;
    data.state = this.shared.orderDetails.delivery_state;
    data.city = this.shared.orderDetails.delivery_city;
    data.country_id = this.shared.orderDetails.delivery_country_id;
    data.postcode = this.shared.orderDetails.delivery_postcode;
    data.zone = this.shared.orderDetails.delivery_zone;
    data.street_address = this.shared.orderDetails.delivery_street_address;
    data.email_address = this.shared.orderDetails.delivery_street_address;
    data.products_weight = '0'; //this.calculateWeight();
    data.products_weight_unit = 'g'
    data.products = this.shared.cartProducts;
    data.region = this.shared.customerData.region;

    console.log("Data Post:",data);

    for (let value of data.products) {
        //check if any product has custom pricing
        if(value.arSpecial == 1){
      //console.log("SPECIAL PRICING");
        isSpecialPricing = true;
        }
      }
      if(isSpecialPricing ){
        data.region  = '9999999';
      }
    this.http.post(this.config.url + 'getPickup', data).map(res => res.json()).subscribe(data => {
      this.loading.hide();
      //  console.log("Response:",data);
      if (data.success == 1) {


        //console.log("Shipping:",data);
        //this.shippingMethod = Object.keys(m).map(function (key) { return m[key]; });
        this.shippingMethod = data;
        this.shared.orderDetails.shipping_cost= '0';
        this.shared.orderDetails.total_tax = '0';
      }
    });



  }
  //================================================================================
  //calcualting products total weight
  calculateWeight = function () {
    var pWeight = 0;
    var totalWeight = 0;
    for (let value of this.shared.cartProducts) {
      pWeight = parseFloat(value.weight);
      if (value.unit == 'kg') {
        pWeight = parseFloat(value.weight) * 1000;
      }
      //  else {
      totalWeight = totalWeight + pWeight
      //   }
      //  console.log(totalWeight);
    }
    return totalWeight;
  };
  setMethod(data) {
    //console.log("Shipping Method:",data)
    this.selectedMethod = false;
    this.shared.orderDetails.shipping_cost = data.rate;
    this.shared.orderDetails.shipping_method = data.Name ;
    // console.log(this.shared.orderDetails);
  }
  openOrderPage() {
    this.navCtrl.push(OrderPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/shipping-method/shipping-method.ts